import styled from 'styled-components';
import FlexContainer from "./FlexContainer";

const StyledFlexContainer = styled(FlexContainer)`
	gap: ${(p) => p.theme.spacing(1)} ${(p) => p.theme.spacing(2)};
	margin-top: ${(p) => p.theme.navHeight}px;
	align-items: flex-start;
	justify-content: flex-end;
	flex-wrap: wrap;
	height: 45vh;
	padding: ${(p) => p.theme.spacing(1)};
`;

export const StyledFixedContainer = styled(FlexContainer)`
	gap: ${(p) => p.theme.spacing(1)} ${(p) => p.theme.spacing(2)};
	top: ${(p) => p.theme.navHeight + p.theme.panelGutter}px;
	height: 100vh;
    width: 19vw;
    position: fixed;
	padding: ${(p) => p.theme.spacing(1)};
    overflow-y: hidden;	
    z-index: 1000;
	
	@media screen and (max-width: ${(p) => p.theme.breakpoints.values.sm}px) {
		overflow-x: hidden;	
	}
`;

export default StyledFlexContainer;
